<template>
  <div class='container'>
      <button class="ui button">headline按钮</button>
  </div>
</template>
<script>
export default {
    name:'MyHeadline'
  }
</script>
<style scoped lang='less'></style>